const IDENTIFY_KEY = 'FORK#IDENTIFY'

const idnetifiedGroupMap: Record<
  string,
  { locationGroupId: number; name: string }
> = {
  KARROT: {
    locationGroupId: 1,
    name: '당근마켓',
  },
  NBT: {
    locationGroupId: 2,
    name: '엔비티(NBT)',
  },
}

export const getGroupCode = () => {
  return window.localStorage.getItem(IDENTIFY_KEY)
}

export const setGroupCode = (groupCode: string) => {
  return window.localStorage.setItem(IDENTIFY_KEY, groupCode)
}

export const toLocationGroupId = (groupCode: string) => {
  const group = idnetifiedGroupMap[groupCode]

  return group ? group.locationGroupId : null
}

export const toLocationGroupName = (groupCode: string) => {
  const group = idnetifiedGroupMap[groupCode]

  return group ? group.name : null
}

export const identify = async (groupCode: string) => {
  const identified = toLocationGroupId(groupCode) ? true : false

  if (identified) {
    setGroupCode(groupCode)
  }

  return identified
}

export const logout = () => {
  window.localStorage.removeItem(IDENTIFY_KEY)
}
